import type { TotalCellProps } from './types'

import * as S from './styles'

/**
 * Célula de total com rótulo empilhado: rótulo em cima (12px) e valor em negrito embaixo (16px),
 * ambos seguindo o alinhamento da coluna. Cabe nos 48px da linha, então a altura não muda.
 */
export const TotalCell = ({ label, value, align, isNegative }: TotalCellProps) => (
  <S.Container align={align}>
    <S.Label>{label}</S.Label>
    <S.Value isNegative={isNegative}>{value}</S.Value>
  </S.Container>
)
